import React from 'react';

export default function PhysicianPageHeader({ badge, title, description, actions }) {
  return (
    <header className="ph-page-header ph-no-print mb-4">
      <div className="ph-page-header__main">
        <div className="ph-page-header__text">
          {badge && <span className="ph-page-header__badge">{badge}</span>}
          <h1 className="ph-page-title mb-1">{title}</h1>
          {description && <p className="ph-page-header__desc mb-0">{description}</p>}
        </div>
        {actions ? <div className="ph-page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}
